var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-banner',_vm._g({attrs:{"title":_vm.s__('AutoRemediation|Introducing GitLab auto-fix'),"button-text":_vm.__('Learn more'),"button-link":_vm.helpPagePath,"variant":"introduction"}},_vm.$listeners),[_c('p',[_vm._v("\n    "+_vm._s(_vm.s__(
        "AutoRemediation|If you're using dependency and/or container scanning, and auto-fix is enabled, auto-fix automatically creates merge requests with fixes to vulnerabilities.",
      ))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }